import { Helmet } from "react-helmet";
import ContactBody from "../components/contact/ContactBody";
import PageHero from "../components/reusables/hero/PageHero";

export default function Contact() {
  return (
    <>
      <Helmet>
        <link rel="canonical" href="https://www.ntuna.com/solutions/contacts" />
        <meta
          name="description"
          content="Contact NTUNA.COM for Website, system or app development, ICT consultancy and equipments supply, Digital Marketing, CCTV & IT Security and Networking."
        />
        
        <meta
          property="og:description"
          content="Contact NTUNA.COM for Website, system or app development, ICT consultancy and equipments supply, Digital Marketing, CCTV & IT Security and Networking."
        />
        <meta property="og:title" content="NTUNA.COM | Contacts" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />

        <meta name="twitter:title" content="NTUNA.COM | Contacts" />
        <meta name="twitter:text:title" content="NTUNA.COM | Contacts" />
        <meta
          name="twitter:description"
          content="Contact NTUNA.COM for Website, system or app development, ICT consultancy and equipments supply, Digital Marketing, CCTV & IT Security and Networking."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1779627080/ntuna_head_office_banner_1200x628_bjwamc.jpg"
        />
        <title>NTUNA.COM | Contacts</title>
      </Helmet>
      <PageHero
        classes="world-bg"
        titleClasses="title uppercase ntuna-text-fill"
        title="Contact NTUNA.COM"
      />
      <ContactBody />
    </>
  );
}
